import { CardBodyDetails } from "./card-body";
import { CardHeader } from "./card-header";

export class CardDetail {
    carHeader: CardHeader;
    cardBody: CardBodyDetails[];
    tableHeaders: string[];

    constructor(carHeader: CardHeader, cardBody: CardBodyDetails[], tableHeaders: string[]) {
        this.carHeader = carHeader;
        this.cardBody = cardBody;
        this.tableHeaders = tableHeaders;
    }
}

